var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"colors-component"},[_c('ul',{staticClass:"colors-component__list"},_vm._l((_vm.colors),function(c,i){return _c('li',{key:i,staticClass:"colors-component__list-item",class:{
        'colors-component__list-item--active': c === _vm.color,
      },style:({ background: c, color: c }),on:{"click":function($event){return _vm.$emit('color', c)}}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }